import type { Step } from "react-joyride";

export const contractsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການສັນຍາ! ຫນ້ານີ້ຈະສະແດງສັນຍາທັງໝົດຂອງທ່ານ. ທ່ານສາມາດສ້າງ, ແກ້ໄຂ, ເບິ່ງລາຍລະອຽດ, ຫຼືລຶບສັນຍາໄດ້ຈາກຫນ້ານີ້. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="contracts-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງສັນຍາໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງສັນຍາໃໝ່. ທ່ານຈະສາມາດຕື່ມຂໍ້ມູນສັນຍາ, ເລືອກປະເພດ, ກຳນົດວັນທີເລີ່ມ ແລະ ວັນທີຫມົດອາຍຸ, ແລະອື່ນໆ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="contracts-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາສັນຍາຕາມຊື່ສັນຍາ ຫຼື ຄູ່ສັນຍາ. ທ່ານຍັງສາມາດກອງສັນຍາທີ່ຫມົດອາຍຸແລ້ວ. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="contracts-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງສັນຍາທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຫຼືລຶບສັນຍາໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະສັນຍາ. ທ່ານຍັງສາມາດກົດທີ່ຫົວຂໍ້ຕາຕະລາງເພື່ອຈັດລຽງຂໍ້ມູນ.",
    placement: "top",
  },
];
